<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="primary--text">What is DoleFund?</h1>

        <p>
          DoleFund is a platform that enables individuals to support non-profit organizations and charities with the supplies that they need.
        </p>

        <p>
          Our goal is to create transparencey in the donation process so that you, the individual, can see exactly how your donations are used, while streamlining the process for non-profit organizations in that they receive items you donate directly to their doorstep.
        </p>

        <p>
          You can think of DoleFund as a registry for non-profits.
        </p>

        <p>
          DoleFund will be accepting applications from non-profits and charities in 2020. More information can be found <router-link to="/organizations">here</router-link>.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'About',
  }
</script>
